export default __webpack_public_path__ + "static/media/signUp.d8513c40.jpg";